module.exports = __webpack_public_path__ + "img/pos.cc16962.png";